import { Dialog, DialogContent, DialogTitle } from '@tempmee/react';
import { InterviewInviteSection } from '~/components/counterJobs/OpenJobScreenRedesign/InterviewInviteSection';
import type { IInterviewInviteTarget } from '~/components/counterJobs/OpenJobScreenRedesign/useInterviewInvite';

interface IPostingInterviewInviteDialogProps {
  target: IInterviewInviteTarget;
  /** The interview's day, e.g. "Thu, Sep 3, 2026". */
  date: string;
  onClose: () => void;
  onInvited: () => void;
}

/**
 * The envelope on an open interview's card: Interview Details' own invite — the
 * posting's applicants, the ones already invited shown as Sent — in a dialog over
 * Posting Details.
 */
export const PostingInterviewInviteDialog = ({
  target,
  date,
  onClose,
  onInvited,
}: IPostingInterviewInviteDialogProps) => (
  <Dialog open onClose={onClose} size="large" data-cy="posting-interview-invite">
    <DialogTitle>{`Onsite Interview · ${date}`}</DialogTitle>
    <DialogContent>
      <InterviewInviteSection target={target} onInvited={onInvited} />
    </DialogContent>
  </Dialog>
);
